import { useLocation, useNavigate } from 'react-router-dom';

import {
  EnvelopeAllowedActionsButton,
  EnvelopeAllowedActionsName,
  BrowserStorage, isDevelopment,
  Modal,
} from '@const/consts'
import { Path } from '@const/paths';
import {  displayConfirmNotification, displayErrorNotification } from '@utils/utils';

import EnvelopesService from '@services/envelopes'
import SharedService from '@services/shared'

import { IHandleAllowedAction } from '@views/envelopes/types';
import { IConfirmNotificationOptions } from '@utils/types';
import { useLoadEnvelopes } from '@hooks/envelopes/useLoadEnvelopes';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../redux';
import { setModal } from '@app/store/modules/modal';

export const useAllowedActions = () => {
  const { t } = useTranslation(['envelope'])
  const navigate = useNavigate()
  const location = useLocation()
  const { loadCurrentEnvelope, loadEnvelopes } = useLoadEnvelopes()
  const { pathname, search } = location
  const dispatch = useAppDispatch()
  const personalBoxOguid = useAppSelector((state) => state.user.profile.boxOguid);

  const sharedBranch =
    window.location.hostname === 'f-gdf-main.dev.info-logistics.eu'
      ? 'main'
      : 'dev';
  const getSharedLink = (sharedOguid: string) =>
    isDevelopment
      ? `https://f-shared-gd-${sharedBranch}.dev.info-logistics.eu/${sharedOguid}`
      : `https://shared.${window.location.hostname}/${sharedOguid}`;


  const handleClickAllowedActions = ({ option, oguid, subject, isCurrentEnvelope = false, boxOguid, isQualifiedSignature }: IHandleAllowedAction): void => {
    const { name } = option

    const openValues: string[] = [
      EnvelopeAllowedActionsName.OPEN,
      EnvelopeAllowedActionsButton.VIEW
    ]

    const signedActionsValues: string[] = [
      EnvelopeAllowedActionsButton.APPROVE,
      EnvelopeAllowedActionsButton.SIGN,
    ]

    const isOpen = openValues.includes(name);
    const isSignedAction = signedActionsValues.includes(name);
    const isStopProcess = name === EnvelopeAllowedActionsName.STOP_PROCESS;
    const isDeclineProcess = name === EnvelopeAllowedActionsName.DECLINE;

    if (isOpen && oguid) {
      const url = pathname + search
      localStorage.setItem(BrowserStorage.LAST_URL, url)
      let path = Path.ENVELOPE.replace(':oguid', oguid)

      if (personalBoxOguid !== boxOguid) {
        path = Path.ENVELOPE_BUSINESS.replace(':boxOguid', boxOguid).replace(':oguid', oguid);
      }

      navigate(path)
    }

    if (isDeclineProcess && oguid) {
      dispatch(setModal(Modal.DECLINE))
    }

    if (isStopProcess && oguid) {
      const notify: IConfirmNotificationOptions = {
        title: t('envelope:notification:stopProcessTitle'),
        content: `${t(
          'envelope:notification:stopProcessContent'
        )} "${subject}"?`,
        theme: 'danger',
        onSubmit: () => {
          EnvelopesService.postEnvelopeFlowStop(oguid)
            .then(() => {
              isCurrentEnvelope ? loadCurrentEnvelope() : loadEnvelopes();
            })
            .catch(displayErrorNotification);
        },
      };

      displayConfirmNotification(notify);
    }

    if (isSignedAction && oguid) {
      if (isQualifiedSignature) {
        dispatch(setModal(Modal.ENVELOPE_SIGN))
      } else {
        SharedService.getSharedOguid(oguid)
          .then(({ data }) => {
            window.open(getSharedLink(data), '_blank')
          })
          .catch(displayErrorNotification)
      }
    }
  }

  return {
    handleClickAllowedActions
  }
}
